var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 412,
    viewBox: "0 0 332 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8519_858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.004 206.002H204.006M231.225 192.558L204.222 191.615M231.936 180.169L204.961 178.283M234.994 154.48L208.319 149.777M206.233 164.893L233.092 168.191M237.139 142.653L210.63 137.018M239.931 130.15L213.62 123.59M256.367 81.305L231.593 70.2751M226.534 82.5581L251.69 92.722M247.055 105.573L221.551 96.2907M217.624 108.72L243.568 116.652M262.094 68.8635L237.954 56.5635M268.062 57.2668L244.404 44.1527M281.253 35.2136L259.201 19.7722M251.15 32.4251L274.047 46.7326M288.724 24.3682L267.309 8.23125M296.171 14.4795L275.429 -2.31745M304.899 3.87894L284.268 -12.8281M231.219 221.442L204.216 222.385M231.93 233.831L204.956 235.717M234.988 259.52L208.313 264.223M206.227 249.107L233.087 245.809M237.133 271.347L210.624 276.982M239.925 283.85L213.614 290.41M256.361 332.695L231.587 343.725M226.528 331.442L251.685 321.278M247.049 308.427L221.545 317.709M217.618 305.28L243.562 297.348M262.088 345.136L237.948 357.436M268.056 356.733L244.398 369.847M281.247 378.786L259.195 394.228M251.144 381.575L274.041 367.267M288.718 389.632L267.304 405.769M296.165 399.52L275.423 416.317M304.893 410.121L284.262 426.828",
    stroke: "#9F9F9F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.392 417C204.535 360.82 175 287.702 175 207.756C175 123.217 208.025 46.3139 262 -11",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gauge-progress",
    d: "M190.155 416.314C153.097 358.376 131 285.354 131 206.001C131 126.648 153.097 53.6258 190.155 -4.3125",
    stroke: "#3962D4",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.155 416.314C153.097 358.376 131 285.354 131 206.001C131 126.648 153.097 53.6258 190.155 -4.3125",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.631 205.184L189.031 201.755C189.425 201.448 190 201.729 190 202.228V208.828C190 209.317 189.446 209.601 189.049 209.315L184.649 206.145C184.325 205.911 184.316 205.43 184.631 205.184Z",
    fill: "#3962D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 206H95M241 206H247.5",
    stroke: "#3962D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2236 205.158L44.9333 201.624C44.5346 201.357 44 201.643 44 202.122V208.924C44 209.394 44.5156 209.682 44.9153 209.435L50.2056 206.167C50.5772 205.938 50.5868 205.401 50.2236 205.158Z",
    fill: "#3962D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8519_858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 412,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleWeightIcon);
export default __webpack_public_path__ + "static/media/VehicleWeightIcon.401c0de213dd83a2abaea99417eb96e0.svg";
export { ForwardRef as ReactComponent };